import template from './CustomHeadersView.html';
class CustomHeadersController {
    constructor() {
        this.customHeadersList = [];
        this.onKeyChange = (event) => this.onFieldChange(event, 'key');
        this.onValueChange = (event) => this.onFieldChange(event, 'value');
        this.onFieldChange = (event, field) => {
            const targetElement = event.target;
            const index = targetElement.dataset.index;
            const newFieldValue = event.detail.value;
            this.customHeadersList[index] = {
                ...this.customHeadersList[index],
                [field]: newFieldValue,
            };
            this.validation();
        };
    }
    removeHeader(index) {
        this.customHeadersList.splice(index, 1);
        this.validation();
    }
    addHeader() {
        this.customHeadersList = [...(this.customHeadersList || []), {}];
    }
}
export const CustomHeadersComponent = {
    template,
    controller: CustomHeadersController,
    controllerAs: '$ctrl',
    bindings: {
        customHeadersList: '=',
        validation: '&',
    },
};
